export default "__VITE_ASSET__C11q1Abq__"